import type { Component } from "solid-js";
import type { IconProps } from "./types";

const SalesIcon: Component<IconProps> = (props) => {
  const size = props.size || 16;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke-width="1.5"
      stroke="currentColor"
      width={size}
      height={size}
      class={props.class}
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M2.25 18.75a60.07 60.07 0 0 1 15.797 2.101c.727.198 1.453-.342 1.453-1.096V18.75M3.75 4.5v.75A.75.75 0 0 1 3 6h-.75m0 0v-.375c0-.621.504-1.125 1.125-1.125H3.75m0 0h15.75m0 0v-.375c0-.621-.504-1.125-1.125-1.125H18.5m0 0V4.5c0 .828.672 1.5 1.5 1.5v-.75m0 0v16.75A.75.75 0 0 1 19.25 21H4.75A.75.75 0 0 1 4 20.25V3.75c0-.414.336-.75.75-.75h14.5c.414 0 .75.336.75.75v16.5c0 .414-.336.75-.75.75H4.75A.75.75 0 0 1 4 20.25V4.5"
      />
    </svg>
  );
};

export default SalesIcon;
